import React, { Component } from 'react';

export default class Directory extends Component {

    renderImage() {
        if (this.props.image) {
            return <img className="d-flex mr-3 rounded-circle img-thumbnail thumb-lg" src={this.props.image} alt="Generic placeholder image" />;
        }

        return (
            <span
                className="d-flex mr-3 rounded-circle img-thumbnail thumb-lg letter-placeholder"
            >
                {this.props.title[0].toUpperCase()}
            </span>
        );
    }

    render() {
        return (
            <div className="card m-b-20 ml-0">
                <a className="card-block" href={this.props.href || '#'}>
                    <div className="media">
                        {this.renderImage()}
                        <div className="media-body">
                            <h5 className="mt-0 font-18 mb-1">{this.props.title}</h5>
                            <p className="text-muted font-14">{this.props.subTitle}</p>

                            {this.props.children}
                        </div>
                    </div>
                </a>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./web/src/components/common/directory/Directory.jsx